export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12042.87e6f27b.jpg";